import styled from 'styled-components'

export const MainContainer = styled.div`
  button {
    background: #007bff;
    border: none;
    color: #fff;
    padding: 8px 15px;
    border-radius: 4px;
    cursor: pointer;
    margin: 5px;
  }

  h3 {
    font-weight: 400;
    margin: 40px 0px 20px 0px;
  }

  .row-title {
    width: 100px;
    align-self: center;
    font-size: 14px;
  }
`
